'use strict';

// import mpro from './mpro.init';

/**
 * Clean the code string before it is evaluated
 *
 * @param {string} code
 *
 * @return {string}
 */
mpro.cleanEvalCode = function (code) {
	// Remove trailing spaces and commas
	return code.replace(/[\s;]+$/, '');
};

/**
 * Test the provided code if it's safe to eval
 *
 * @param {string} code
 *
 * @return {boolean}
 */
mpro.testEvalCode = function (code, returnBody) {

	var reSeemsLikeFunction = /^\s*function\s*(?:[a-zA-Z0-9_\$]+)?\s*\(([a-zA-Z0-9\s,_\$]+)?\)\s*\{\s*([\s\S]+)?\s*\}\s*$/;
	var matchFunctionStart;
	returnBody = (typeof returnBody === 'undefined') ? false : returnBody;

	// Capture the function definition, arguments and starting brace
	if (matchFunctionStart = code.match(reSeemsLikeFunction)) {
		var functionArgs = matchFunctionStart[1];
		var functionBody = matchFunctionStart[2];
		// TODO: test cases where someone might add something like the following:
		// function(a, b) { console.log('a:', a, 'b:', b); },console.log('cook', document.cookie),\nfunction(x, y) { console.log('X:', x, 'Y:', y) }
		return returnBody ? {
			args: functionArgs && functionArgs.split(',') || [],
			body: functionBody
		} : true;
	}
	return false;
};

/**
 * Get a function object from the given javascript code
 *
 * @param {string} code
 * @param {string} callbackType
 * @param {?{ thisArg: any=, dataArg: any= }} doBind
 *
 * @return {Function}
 */
mpro.getFnFromCode = function (code, callbackType, doBind) {

	// Remove extra characters from the code
	var codeToEval = mpro.cleanEvalCode(code);
	var fnData = mpro.testEvalCode(codeToEval, true);
	var fn;
	var bindArgs = [];
	if (doBind) {
		if (doBind.thisArg) {
			bindArgs[0] = doBind.thisArg;
		}
		if (doBind.dataArg) {
			bindArgs[1] = doBind.dataArg;
		}
	}

	// Check if code has a function pattern
	if (fnData) {
		fn = Function(fnData.args, fnData.body);
		if (bindArgs.length) {
			fn = Function.prototype.bind.apply(fn, bindArgs);
		}
	}
	// Deprecated code specimen, without a function body
	else {
		// eslint-disable-next-line no-console
		console.warn(
			'%c[SHM]', mpro.consoleStyle, 'Trying to evaluate deprecated code in the \'' + callbackType + '\' handler:\n',
			'\n' + codeToEval + '\n',
			'\nPlease convert your code to a single function signature like this:',
			'\n\nfunction() {\n\t' + codeToEval + '\n}\n',
			'\ndataArg:', doBind && doBind.dataArg || undefined
		);
		// codeToEval = '(function(type, data, resp) {\n' + code + '\n}).call(thisArg, callbackType, dataArg.instance.options, dataArg.response);';
		fn = Function([], codeToEval);
		if (bindArgs.length) {
			fn = Function.prototype.bind.apply(fn, bindArgs);
		}
	}

	return fn;
};

/**
 * Evaluate the code string in the current context
 *
 * @param {string} code
 * @param {string} callbackType
 * @param {object} thisArg
 * @param {any[]} argsArr
 *
 * @return {any}
 */
mpro.evalCode = function (code, callbackType, thisArg, argsArr) {

	var fn = (typeof code === 'function') ? code : mpro.getFnFromCode(code, callbackType);
	var retVal = undefined;

	// Try to evaluate the code in the function context
	try {
		retVal = fn.apply(thisArg, argsArr);
	}
	catch (e) {
		// eslint-disable-next-line no-console
		console.error(
			'%c[SHM]', mpro.consoleStyle,
			'Error while evaluating the code in the \'' + callbackType + '\' callback',
			'\ncode:\n', '\n' + code + '\n',
			'\nargsArr:', argsArr,
			'\nException:\n', e
		);
	}

	return retVal;
};

/**
 * Search and replace object string values with functions
 *
 * @param {{}} obj
 * @param {{}} searchKeys
 */
mpro.objectValsToFunction = function (obj, searchKeys) {
	Object.keys(searchKeys).forEach(function (key) {
		if (key in obj) {
			// Recursive
			if ((searchKeys[key] !== null) && (typeof searchKeys[key] === 'object')) {
				mpro.objectValsToFunction(obj[key], searchKeys[key]);
			}
			// Truthful value
			else if ((searchKeys[key] == true) && (typeof obj[key] === 'string')) {
				obj[key] = mpro.getFnFromCode(obj[key], `Object ${key} js`);
			}
		}
	});
};

export default mpro;
